import * as React from 'react';
import { NotFoundSvg } from '../../components/Assets';
import SolidBlueBtn from '../../components/buttons/SolidBlueBtn';
const NotFound = () => {
    const onClick = () => {
       window.location.replace(window.location.origin);
    }
    return (
        <div
            className="flex justify-center items-center "
            style={{
                height: "calc(105vh - 100px)",
            }}
        >
            <div className="flex items-center justify-center flex-col px-5 w-full">
                <img src={NotFoundSvg} />
                <div className="mt-6 text-darkblue font-bold text-18 ">
                    페이지를 찾을 수 없어요.
                </div>
                <div className="mt-3 text-15 ">
                    페이지가 존재하지 않거나 사용할 수 없어요.
                </div>
                <div className="text-15 ">
                    입력하신 주소를 다시 한번 확인해 주세요.
                </div>
                <SolidBlueBtn
                    className="w-[5.5rem] h-[2.313rem] mt-5  flex items-center justify-center"
                    onClick={onClick}
                >
                    홈으로 가기
                </SolidBlueBtn>
            </div>
        </div>
    );
};
export default NotFound;